module.exports = __webpack_public_path__ + "static/media/landing_image.b8694cc6.png";